export enum StripeConnectedAccountStatusEnum {
	OnboardingRequired = 'onboarding-required',
	PendingOnboarding = 'pending-onboarding',
	FailedOnboarding = 'failed-onboarding',
	SuccessfulOnboarding = 'successful-onboarding',
}